<template>
  <div class="profile-box-container w-100">
    <div class="d-flex justify-space-between align-items-center w-100">
      <div class="d-flex flex-column ga-4">
        <label class="profile-box-title"> {{ $t("profile_picture") }} </label>
        <label class="profile-box-desc">
          {{ $t("a_picture_helps_people_to_recognize_you") }}
        </label>
      </div>

      <div class="d-flex align-center ga-4">
        <!-- Skeleton Mode -->
        <template v-if="!profile || !profile.first_name">
          <v-skeleton-loader
            type="avatar"
            class="profile-picture"
            width="64"
            height="64"
          />
          <div class="d-flex flex-column ga-2">
            <v-skeleton-loader type="text" width="150" height="20" />
            <v-skeleton-loader type="text" width="100" height="16" />
          </div>
        </template>

        <!-- Real Data -->
        <template v-else>
          <span class="profile-picture position-relative">
            <img :src="profile.image" :alt="profile.first_name" />
          </span>
          <span class="d-flex flex-column ga-2">
            <span class="profile-box-main-text profile-box-name">
              {{ profile.first_name + " " + profile.last_name }}
            </span>
            <span class="profile-box-second-text">{{ profile.role }}</span>
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfilePicture",
  props: ["profile"],
};
</script>
